const LABELS = {
    Management: 'User / Asset Management', // deprecated: remove when Nav v2 adopted for all regions
    Accounting: 'Accounting', // deprecated: remove when Nav v2 adopted for all regions
    Pooling: 'Pooling',
    General: 'General',
    RawMilkTracking: 'Raw Milk Tracking',
    ProcessedFluidTracking: 'Processed Fluid Tracking',
    Quality: 'Quality',
    Invoicing: 'Invoicing',
    Payroll: 'Payroll',
    Memberships: 'Memberships',
    UsersAndAssets: 'Users and Assets',
    Demurrage: 'Demurrage',
    SubProducerLabel: 'Permissions',
};

export const SCHREIBER_PROCESSOR_ID = '60cce1348ada14e90f0783e8';

export default LABELS;
